<template>
  <div v-if="profile.status === 'Available'">
    <!-- Premium Header Section -->
    <v-container fluid class="pa-0">
      <div class="header-container">
        <v-row class="mb-6" align="center">
          <v-col cols="12" md="8" class="d-flex align-start">
            <!-- <v-img
                v-if="!isMember"
                src="@/assets/svg/competitionhead.svg"
                width="45"
                height="45"
                contain
                class="mt-5"
              ></v-img> -->
            <h3
              class="text-h3 font-weight-bold gradient--text mt-5"
              v-if="!isMember"
            >
              All Competition Challenge Management
            </h3>
          </v-col>
          <v-col cols="12" md="4" class="text-right">
            <v-btn
              color="#fff"
              outlined
              @click="loadMembers"
              class="mr-2"
              elevation="1"
            >
              <v-icon left>mdi-refresh</v-icon>
              Refresh
            </v-btn>
            <v-btn color="primary" @click="exportToCSV" elevation="1">
              <v-icon left>mdi-download</v-icon>
              Export
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <!-- Stats Cards with Animation -->
      <v-row class="mb-4">
        <v-col cols="12" sm="6" md="3">
          <v-card
            class="stat-card"
            elevation="2"
            @click="filterByStatus('all')"
          >
            <div class="d-flex align-center pa-4">
              <div class="icon-container blue">
                <v-icon size="20" color="white">mdi-account-multiple</v-icon>
              </div>
              <div class="stat-content ml-3">
                <div class="text-caption text-uppercase font-weight-medium">
                  Total Requests
                </div>
                <div class="text-h6 font-weight-bold">{{ members.length }}</div>
              </div>
            </div>
            <div class="stat-indicator blue"></div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="stat-card"
            elevation="2"
            @click="filterByStatus('Pending')"
          >
            <div class="d-flex align-center pa-4">
              <div class="icon-container orange">
                <v-icon size="20" color="white">mdi-clock-outline</v-icon>
              </div>
              <div class="stat-content ml-3">
                <div class="text-caption text-uppercase font-weight-medium">
                  Pending
                </div>
                <div class="text-h6 font-weight-bold">{{ pendingCount }}</div>
              </div>
            </div>
            <div class="stat-indicator orange"></div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="stat-card"
            elevation="2"
            @click="filterByStatus('Accepted')"
          >
            <div class="d-flex align-center pa-4">
              <div class="icon-container green">
                <v-icon size="20" color="white">mdi-check-circle</v-icon>
              </div>
              <div class="stat-content ml-3">
                <div class="text-caption text-uppercase font-weight-medium">
                  Approved
                </div>
                <div class="text-h6 font-weight-bold">{{ approvedCount }}</div>
              </div>
            </div>
            <div class="stat-indicator green"></div>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="stat-card"
            elevation="2"
            @click="filterByStatus('Rejected')"
          >
            <div class="d-flex align-center pa-4">
              <div class="icon-container red">
                <v-icon size="20" color="white">mdi-close-circle</v-icon>
              </div>
              <div class="stat-content ml-3">
                <div class="text-caption text-uppercase font-weight-medium">
                  Rejected
                </div>
                <div class="text-h6 font-weight-bold">{{ rejectedCount }}</div>
              </div>
            </div>
            <div class="stat-indicator red"></div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Main Data Table Card -->
      <v-card class="elevation-3 rounded-lg">
        <v-card-title class="table-card white--text">
          <v-icon color="white" left>mdi-account-group</v-icon>
          Competition Requests
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search members..."
            single-line
            hide-details
            dark
            class="shrink"
          ></v-text-field>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="filteredMembers"
            :search="search"
            :loading="loading"
            loading-text="Loading... Please wait"
            class="elevation-1"
            mobile-breakpoint="0"
          >
            <template v-slot:item.sno="{ index }">
              <v-chip color="#fff" small>{{ index + 1 }}</v-chip>
            </template>

            <template v-slot:item.full_name="{ item }">
              <div class="d-flex align-center">
                <v-avatar color="primary" size="36" class="mr-3">
                  <v-img
                    v-if="
                      item.volunteer_id._id && item.volunteer_id.midThumbnail
                    "
                    :src="item.volunteer_id.midThumbnail"
                  ></v-img>
                  <v-img
                    v-else-if="item.agency_id && item.agency_id.midThumbnail"
                    :src="item.agency_id.midThumbnail"
                  ></v-img>
                  <span class="white--text" v-else>
                    {{ getInitials(item.full_name || item.name) }}
                  </span>
                </v-avatar>
                <div>
                  {{
                    item.volunteer_id?.first_name &&
                    item.volunteer_id?.last_name
                      ? item.volunteer_id.first_name +
                        " " +
                        item.volunteer_id.last_name
                      : item.agency_id?.name || item.name
                  }}
                </div>
              </div>
            </template>

            <template v-slot:item.request_date="{ item }">
              <v-chip small >
                {{ item.request_date }}
              </v-chip>
            </template>

            <template v-slot:item.response_status="{ item }">
              <v-chip small :color="getStatusColor(item.response_status)" dark>
                {{ item.response_status }}
              </v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
              <div class="d-flex" v-if="item.response_status !== 'Rejected'">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab
                      outlined
                      x-small
                      color="success"
                      class="mr-2"
                      @click.stop="approveMember(item)"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="item.response_status === 'Accepted'"
                      :loading="confirmingResponse === item._id"
                    >
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Approve</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab
                      x-small
                      outlined
                      color="error"
                      @click.stop="rejectMember(item)"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="item.response_status === 'Rejected'"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>Reject</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:no-data>
              <v-alert type="info" class="ma-4">
                No member requests found. Check back later!
              </v-alert>
            </template>

            <template v-slot:no-results>
              <v-alert type="warning" class="ma-4">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Status Snackbar -->
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      multi-line
      timeout="3000"
      bottom
    >
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>

    <!-- Confirmation Dialog -->
    <v-dialog v-model="confirmDialog" max-width="400">
      <v-card>
        <v-card-title class="headline"> Confirm Action </v-card-title>
        <v-card-text>
          Are you sure you want to {{ actionType }} this member request?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="confirmDialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" text @click="confirmAction"> Confirm </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

  <!-- Pending/Rejected State -->
  <div
    v-else-if="profile.status === 'Pending' || profile.status === 'Rejected'"
  >
    <v-container fill-height>
      <v-row align="center" justify="center">
        <v-col cols="12" md="8" class="text-center">
          <v-icon size="80" color="warning" class="mb-4"
            >mdi-clock-alert-outline</v-icon
          >
          <h1 class="display-1 mb-4">Account Under Review</h1>
          <p class="headline font-weight-light">
            Your account is currently {{ profile.status.toLowerCase() }}. Please
            wait for administrator approval to access this feature.
          </p>
          <v-btn color="primary" large class="mt-6" @click="$router.push('/')">
            Return to Dashboard
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      selectedItem: null,
      actionType: "",
      confirmDialog: false,
      selectedAgency: null,
      isToggled: false,
      regForm: true,
      confirmingResponse: "",
      responseStatus: "",
      errorMessage: null,
      snackbar: false,
      snackbarColor: "error",
      members: [],
      profiledata: null,
      isMember: null,
      value: null,
      loading: false,
      currentFilter: "all",
      headers: [
        { text: "#", value: "sno", align: "center", width: "80px" },
        { text: "Member", value: "full_name", sortable: true },
        {
          text: "Competition Title",
          value: "competitionId.title",
          sortable: true
        },
        {
          text: "Request Date",
          value: "request_date",
          align: "center",
          width: "150px"
        },
        {
          text: "Response Date",
          value: "response_date",
          align: "center",
          width: "150px"
        },
        {
          text: "Status",
          value: "response_status",
          align: "center",
          width: "120px"
        },
        {
          text: "Actions",
          value: "actions",
          align: "center",
          sortable: false,
          width: "180px"
        }
      ]
    };
  },
  computed: {
    formattedMembers() {
      return this.members.map(member => ({
        ...member,
        full_name:
          member.volunteer_id && member.volunteer_id._id
            ? `${member.volunteer_id.first_name} ${member.volunteer_id.last_name}`
            : member.company_id && member.company_id.name
            ? member.company_id.name
            : "-",
        request_date: member.createdAt
          ? this.formatDate(member.createdAt)
          : "-",
        response_date: member.response_date
          ? this.formatDate(member.response_date)
          : "-",
        // Add competition title for table display
        "competitionId.title":
          member.competitionId && member.competitionId.title
            ? member.competitionId.title
            : "-"
      }));
    },
    filteredMembers() {
      if (this.currentFilter === "all") {
        return this.formattedMembers;
      }
      return this.formattedMembers.filter(
        m => m.response_status === this.currentFilter
      );
    },
    pendingCount() {
      return this.members.filter(m => m.response_status === "Pending").length;
    },
    approvedCount() {
      return this.members.filter(m => m.response_status === "Accepted").length;
    },
    rejectedCount() {
      return this.members.filter(m => m.response_status === "Rejected").length;
    },
    ...mapState("auth", {
      profile: "profile"
    })
  },
  methods: {
    ...mapActions({
      fetchAgencyMembers: "members/fetchAgencyMembers",
      activateMember: "members/activateMember",
      fetchMyCompetitionMembers: "members/fetchMyCompetitionMembers"
    }),
    getInitials(name) {
      if (!name) return "?";
      return name
        .split(" ")
        .map(n => n[0])
        .join("")
        .toUpperCase();
    },
    getStatusColor(status) {
      switch (status) {
        case "Accepted":
          return "success";
        case "Rejected":
          return "error";
        default:
          return "warning";
      }
    },
    getDateColor(date) {
      if (date === "-") return "grey";
      const daysOld = moment().diff(moment(date, "MMM D, YYYY"), "days");
      if (daysOld > 7) return "error";
      if (daysOld > 3) return "warning";
      return "primary";
    },
    filterByStatus(status) {
      this.currentFilter = status;
    },
    showErrorMessage(message, type = "error") {
      this.errorMessage = message;
      this.snackbarColor = type;
      this.snackbar = true;
    },
    async loadMembers() {
      try {
        this.loading = true;
        const response = await this.fetchMyCompetitionMembers();
        console.log("Members loaded:", response);
        this.members = response;
        this.loading = false;
        this.showErrorMessage("Member data refreshed successfully", "success");
      } catch (error) {
        this.loading = false;
        const errorMsg = error.response?.data?.message || error.message || "An error occurred while loading members.";
        this.showErrorMessage(errorMsg);
      }
    },
    formatDate(date) {
      return moment(date).format("MMM D, YYYY");
    },
    showConfirmDialog(item, action) {
      this.selectedItem = item;
      this.actionType = action;
      this.confirmDialog = true;
    },
    async confirmAction() {
      this.confirmDialog = false;
      if (this.actionType === "approve") {
        await this.approveMember(this.selectedItem);
      } else {
        await this.rejectMember(this.selectedItem);
      }
    },
    async approveMember(item) {
      const params = {
        member_id: item._id,
        responseStatus: "Accepted"
      };
      this.confirmingResponse = item._id;

      try {
        await this.activateMember(params);
        this.confirmingResponse = "";
        await this.loadMembers();
        this.showErrorMessage("Member approved successfully", "success");
      } catch (error) {
        this.confirmingResponse = "";
        this.showErrorMessage(
          error || "An error occurred while approving the member."
        );
      }
    },
    async rejectMember(item) {
      const params = {
        member_id: item._id,
        responseStatus: "Rejected"
      };

      try {
        await this.activateMember(params);
        await this.loadMembers();
        this.showErrorMessage("Member request rejected", "success");
      } catch (error) {
        this.showErrorMessage(
          error.message || "An error occurred while rejecting the member."
        );
      }
    },
    exportToCSV() {
      const headers = ["Name", "Request Date", "Response Date", "Status"];
      const data = this.formattedMembers.map(member => [
        member.full_name,
        member.request_date,
        member.response_date,
        member.response_status
      ]);

      let csvContent =
        "data:text/csv;charset=utf-8," +
        headers.join(",") +
        "\n" +
        data.map(row => row.join(",")).join("\n");

      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "agency_members.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      this.showErrorMessage("Export started successfully", "success");
    }
  },
  watch: {
    profile(newProfile) {
      this.profiledata = newProfile;
      this.isMember = newProfile.isMember;
    }
  },
  mounted() {
    this.loadMembers();
  }
};
</script>

<style scoped>
.gradient--text {
  background: linear-gradient(45deg, #3a7bd5, #00d2ff);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}

.stat-card {
  transition: all 0.3s ease;
  cursor: pointer;
  border-radius: 12px !important;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
}

.rounded-lg {
  border-radius: 12px !important;
}

.v-card__title.primary {
  border-top-left-radius: 12px !important;
  border-top-right-radius: 12px !important;
}

.v-data-table >>> th {
  font-weight: 600 !important;
  font-size: 0.9rem !important;
  background-color: #f5f7fa !important;
}

.v-data-table >>> .v-chip {
  font-weight: 500;
}

@media (max-width: 960px) {
  .v-data-table >>> .v-data-table__mobile-table-row {
    display: flex;
    flex-direction: column;
    padding: 16px;
    border-bottom: 1px solid #eee;
  }

  .v-data-table >>> .v-data-table__mobile-row {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
  }

  .v-data-table >>> .v-data-table__mobile-row__header {
    font-weight: 600;
    color: rgba(0, 0, 0, 0.6);
  }
}

.header-container {
  background: linear-gradient(135deg, #084468, #0a5b8a);
  padding: 2px 36px;
  border-bottom-left-radius: 56px;
  border-bottom-right-radius: 56px;
  margin-bottom: 28px;
}
.stat-card {
  position: relative;
  transition: box-shadow 0.2s, transform 0.2s;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  background: white;
}
.table-card {
  background: linear-gradient(135deg, #084468, #0a5b8a);
}
.stat-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-2px);
}

.icon-container {
  min-width: 36px;
  height: 36px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.blue {
  background: linear-gradient(135deg, #3361ff, #6087ff);
}

.orange {
  background: linear-gradient(135deg, #ff9f43, #ffb976);
}

.green {
  background: linear-gradient(135deg, #28c76f, #48da89);
}

.red {
  background: linear-gradient(135deg, #ea5455, #f08182);
}

.stat-indicator {
  height: 3px;
  width: 100%;
  position: absolute;
  bottom: 0;
}
</style>
